import React from "react";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";

const createEmotionCache = (dir = "ltr") =>
  createCache({
    key: dir === "rtl" ? "muirtl" : "mui",
    stylisPlugins: dir === "rtl" ? [prefixer, rtlPlugin] : [],
  });

export default createEmotionCache;
